import { render, staticRenderFns } from "./InvertedExpandableList.vue?vue&type=template&id=31b6c67a"
import script from "./InvertedExpandableList.vue?vue&type=script&lang=js"
export * from "./InvertedExpandableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports